const UPDATE_DATA = 'houseAuditList/UPDATE_DATA';
const CLEAR_DATA = 'houseAuditList/CLEAR_DATA';


const initialState = {
    houseCode: "",//房源编号
    admissibility: "",//受理人
    auditStatus: 0,//审核状态
    auditResult: 0,//审核状态
    acceptStatus:0,//受理状态
    timeType:"public",//audit,accept
    timeStart:"",//开始时间,
    timeEnd:"",//结束时间
    ownerName:"",//业主姓名
    ownerPhone:"",//业主手机
    district:"",//区县
    districtSub:"",//乡镇
    community:"",//小区名称
    address:"",//坐落地址

    option:{},//配置选项
    data:[],//展示的数据

    showDivContent:true,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_DATA:
            return {
                ...state,
                [action.subType]: action.data
            };
        case CLEAR_DATA:
            return {
                ...state,
                houseCode: "",//房源编号
                admissibility: "",//受理人
                auditStatus: 0,//审核状态
                auditResult: 0,//审核状态
                acceptStatus:0,//受理状态
                timeType:"public",//audit,accept
                timeStart:"",//开始时间,
                timeEnd:"",//结束时间
                ownerName:"",//业主姓名
                ownerPhone:"",//业主手机
                district:"",//区县
                districtSub:"",//乡镇
                community:"",//小区名称
                address:"",//坐落地址
            };
        default:
            return state
    }
}

export const dispatch_func = {
    update_data : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_DATA,
                subType:type,
                data: data
            });
        };
    },
    clear_data : () => {
        return dispatch => {
            dispatch({
                type: CLEAR_DATA,
            });
        };
    },
};


// WEBPACK FOOTER //
// ./src/modules/houseAuditList.js